import React, { Component } from "react";
import { Checkbox, Table } from "antd";
import { ModalItem, ButtonItem } from "../../../../../Components/Items";
import InputNumberItem from "../../../../../Components/InputNumberItem";

class ModalQuitarApartadoIndividual extends Component {
  state = {
    selectedIndices: [],
    cantidades: {},
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.setState({ selectedIndices: [], cantidades: {} });
    }
  }

  handleToggle(index, apartado) {
    const { selectedIndices, cantidades } = this.state;
    if (selectedIndices.includes(index)) {
      const nuevasCantidades = { ...cantidades };
      delete nuevasCantidades[index];
      this.setState({ selectedIndices: selectedIndices.filter((i) => i !== index), cantidades: nuevasCantidades });
    } else {
      this.setState({
        selectedIndices: [...selectedIndices, index],
        cantidades: { ...cantidades, [index]: apartado },
      });
    }
  }

  handleCantidadChange(index, apartado, value) {
    const cantidad = Math.max(0, Math.min(Number(value) || 0, apartado));
    this.setState({ cantidades: { ...this.state.cantidades, [index]: cantidad } });
  }

  render() {
    const { visible, onCancel, insumos, onConfirm, loading } = this.props;
    const { selectedIndices, cantidades } = this.state;

    const lista = insumos || [];
    const allSelected = lista.length > 0 && selectedIndices.length === lista.length;
    const indeterminate = selectedIndices.length > 0 && selectedIndices.length < lista.length;
    const hayCantidadInvalida = selectedIndices.some(
      (index) => !cantidades[index] || cantidades[index] <= 0
    );

    const columns = [
      {
        title: (
          <Checkbox
            checked={allSelected}
            indeterminate={indeterminate}
            onChange={(e) => {
              if (e.target.checked) {
                const nuevasCantidades = {};
                lista.forEach((i) => { nuevasCantidades[i.index] = i.apartado; });
                this.setState({ selectedIndices: lista.map((i) => i.index), cantidades: nuevasCantidades });
              } else {
                this.setState({ selectedIndices: [], cantidades: {} });
              }
            }}
          />
        ),
        width: 50,
        render: (_, record) => (
          <Checkbox
            checked={selectedIndices.includes(record.index)}
            onChange={() => this.handleToggle(record.index, record.apartado)}
          />
        ),
      },
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        width: 120,
      },
      {
        title: "Insumo",
        dataIndex: "nombre",
        key: "nombre",
      },
      {
        title: "Apartado",
        dataIndex: "apartado",
        key: "apartado",
        width: 100,
        align: "center",
      },
      {
        title: "Cantidad a desapartar",
        key: "cantidad",
        width: 160,
        align: "center",
        render: (_, record) => (
          <InputNumberItem
            sinBorde
            min={0.01}
            step={1}
            max={record.apartado}
            disabled={!selectedIndices.includes(record.index)}
            value={cantidades[record.index]}
            onChange={(value) => this.handleCantidadChange(record.index, record.apartado, value)}
          />
        ),
      },
    ];

    return (
      <ModalItem
        title="Quitar Apartados"
        visible={visible}
        onCancel={() => {
          this.setState({ selectedIndices: [], cantidades: {} });
          onCancel();
        }}
        spinning={loading}
        footer={false}
        width={720}
      >
        <Table
          dataSource={lista.map((i) => ({ ...i, key: i.index }))}
          columns={columns}
          pagination={false}
          size="small"
        />
        <div style={{ marginTop: 16, textAlign: "right" }}>
          <ButtonItem
            style={{ marginRight: 8 }}
            onClick={() => {
              this.setState({ selectedIndices: [], cantidades: {} });
              onCancel();
            }}
          >
            Cancelar
          </ButtonItem>
          <ButtonItem
            type="primary"
            verdeB
            disabled={selectedIndices.length === 0 || hayCantidadInvalida}
            onClick={() => onConfirm(selectedIndices.map((index) => ({ index, cantidad: cantidades[index] })))}
          >
            Quitar Apartados
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

export default ModalQuitarApartadoIndividual;